// Generated by ReScript, PLEASE EDIT WITH CARE

import * as GraphqlTag from "graphql-tag";

var Raw = {};

var query = GraphqlTag.gql(["fragment MenuFragment on AcademyMenuNode   {\n__typename  \nid  \ntitle  \ndescription  \nhasActivities  \nparentId  \n}\n"]);

function parse(value) {
  var value$1 = value.description;
  return {
          __typename: value.__typename,
          id: value.id,
          title: value.title,
          description: !(value$1 == null) ? value$1 : undefined,
          hasActivities: value.hasActivities,
          parentId: value.parentId
        };
}

function serialize(value) {
  var value$1 = value.parentId;
  var value$2 = value.hasActivities;
  var value$3 = value.description;
  var description = value$3 !== undefined ? value$3 : null;
  var value$4 = value.title;
  var value$5 = value.id;
  var value$6 = value.__typename;
  return {
          __typename: value$6,
          id: value$5,
          title: value$4,
          description: description,
          hasActivities: value$2,
          parentId: value$1
        };
}

function verifyArgsAndParse(_MenuFragment, value) {
  return parse(value);
}

function verifyName(param) {
  
}

var MenuFragment = {
  Raw: Raw,
  query: query,
  parse: parse,
  serialize: serialize,
  verifyArgsAndParse: verifyArgsAndParse,
  verifyName: verifyName
};

var Raw$1 = {};

var query$1 = GraphqlTag.gql(["fragment ActivityFragment on AcademyActivity   {\n__typename  \nid  \ntitle  \nmenuNodeId  \nresult  {\n__typename  \nacademyActivityId  \nkind  \ncontentKind  \nbestScoreNumComplete  \nbestScoreNumCorrect  \nbestResponsesScore  \nhasResponsesScore  \nstarted  \nlocales  \n}\n\n}\n"]);

function parse$1(value) {
  var value$1 = value.result;
  var value$2 = value$1.contentKind;
  var tmp;
  switch (value$2) {
    case "audio" :
        tmp = "audio";
        break;
    case "custom_word_list" :
        tmp = "custom_word_list";
        break;
    case "example_sentence" :
        tmp = "example_sentence";
        break;
    case "monster_chef" :
        tmp = "monster_chef";
        break;
    case "not_set" :
        tmp = "not_set";
        break;
    case "phonics" :
        tmp = "phonics";
        break;
    case "sound_train" :
        tmp = "sound_train";
        break;
    case "tupperware" :
        tmp = "tupperware";
        break;
    case "video" :
        tmp = "video";
        break;
    case "whack_a_munk" :
        tmp = "whack_a_munk";
        break;
    case "word" :
        tmp = "word";
        break;
    case "word_list" :
        tmp = "word_list";
        break;
    default:
      tmp = {
        NAME: "FutureAddedValue",
        VAL: value$2
      };
  }
  var value$3 = value$1.bestResponsesScore;
  var value$4 = value$1.locales;
  return {
          __typename: value.__typename,
          id: value.id,
          title: value.title,
          menuNodeId: value.menuNodeId,
          result: {
            __typename: value$1.__typename,
            academyActivityId: value$1.academyActivityId,
            kind: value$1.kind,
            contentKind: tmp,
            bestScoreNumComplete: value$1.bestScoreNumComplete,
            bestScoreNumCorrect: value$1.bestScoreNumCorrect,
            bestResponsesScore: !(value$3 == null) ? value$3 : undefined,
            hasResponsesScore: value$1.hasResponsesScore,
            started: value$1.started,
            locales: value$4.map(function (value) {
                  switch (value) {
                    case "en_AU" :
                        return "en_AU";
                    case "en_BZ" :
                        return "en_BZ";
                    case "en_CA" :
                        return "en_CA";
                    case "en_CB" :
                        return "en_CB";
                    case "en_GB" :
                        return "en_GB";
                    case "en_IE" :
                        return "en_IE";
                    case "en_IN" :
                        return "en_IN";
                    case "en_JM" :
                        return "en_JM";
                    case "en_NZ" :
                        return "en_NZ";
                    case "en_PH" :
                        return "en_PH";
                    case "en_TT" :
                        return "en_TT";
                    case "en_US" :
                        return "en_US";
                    case "en_ZA" :
                        return "en_ZA";
                    case "en_ZW" :
                        return "en_ZW";
                    default:
                      return {
                              NAME: "FutureAddedValue",
                              VAL: value
                            };
                  }
                })
          }
        };
}

function serialize$1(value) {
  var value$1 = value.result;
  var value$2 = value$1.locales;
  var locales = value$2.map(function (value) {
        if (typeof value === "object") {
          return value.VAL;
        } else if (value === "en_BZ") {
          return "en_BZ";
        } else if (value === "en_CA") {
          return "en_CA";
        } else if (value === "en_CB") {
          return "en_CB";
        } else if (value === "en_GB") {
          return "en_GB";
        } else if (value === "en_IE") {
          return "en_IE";
        } else if (value === "en_IN") {
          return "en_IN";
        } else if (value === "en_JM") {
          return "en_JM";
        } else if (value === "en_NZ") {
          return "en_NZ";
        } else if (value === "en_PH") {
          return "en_PH";
        } else if (value === "en_TT") {
          return "en_TT";
        } else if (value === "en_US") {
          return "en_US";
        } else if (value === "en_ZA") {
          return "en_ZA";
        } else if (value === "en_ZW") {
          return "en_ZW";
        } else {
          return "en_AU";
        }
      });
  var value$3 = value$1.started;
  var value$4 = value$1.hasResponsesScore;
  var value$5 = value$1.bestResponsesScore;
  var bestResponsesScore = value$5 !== undefined ? value$5 : null;
  var value$6 = value$1.bestScoreNumCorrect;
  var value$7 = value$1.bestScoreNumComplete;
  var value$8 = value$1.contentKind;
  var contentKind = typeof value$8 === "object" ? value$8.VAL : (
      value$8 === "not_set" ? "not_set" : (
          value$8 === "example_sentence" ? "example_sentence" : (
              value$8 === "word" ? "word" : (
                  value$8 === "word_list" ? "word_list" : (
                      value$8 === "whack_a_munk" ? "whack_a_munk" : (
                          value$8 === "phonics" ? "phonics" : (
                              value$8 === "sound_train" ? "sound_train" : (
                                  value$8 === "tupperware" ? "tupperware" : (
                                      value$8 === "monster_chef" ? "monster_chef" : (
                                          value$8 === "audio" ? "audio" : (
                                              value$8 === "video" ? "video" : "custom_word_list"
                                            )
                                        )
                                    )
                                )
                            )
                        )
                    )
                )
            )
        )
    );
  var value$9 = value$1.kind;
  var value$10 = value$1.academyActivityId;
  var value$11 = value$1.__typename;
  var result = {
    __typename: value$11,
    academyActivityId: value$10,
    kind: value$9,
    contentKind: contentKind,
    bestScoreNumComplete: value$7,
    bestScoreNumCorrect: value$6,
    bestResponsesScore: bestResponsesScore,
    hasResponsesScore: value$4,
    started: value$3,
    locales: locales
  };
  var value$12 = value.menuNodeId;
  var value$13 = value.title;
  var value$14 = value.id;
  var value$15 = value.__typename;
  return {
          __typename: value$15,
          id: value$14,
          title: value$13,
          menuNodeId: value$12,
          result: result
        };
}

function verifyArgsAndParse$1(_ActivityFragment, value) {
  return parse$1(value);
}

function verifyName$1(param) {
  
}

var ActivityFragment = {
  Raw: Raw$1,
  query: query$1,
  parse: parse$1,
  serialize: serialize$1,
  verifyArgsAndParse: verifyArgsAndParse$1,
  verifyName: verifyName$1
};

var Raw$2 = {};

var query$2 = GraphqlTag.gql(["fragment AcademyMatrixCategoryAggregateFragment on AcademyMatrixCategoryAggregate   {\n__typename  \ncategoryId  \navgBestCategoryAttempts  \navgLatestCategoryAttempts  \ntotalCategoryAttempts  \nuniqueActivityCount  \ntotalActivityCount  \n}\n"]);

function parse$2(value) {
  var value$1 = value.avgBestCategoryAttempts;
  var value$2 = value.avgLatestCategoryAttempts;
  var value$3 = value.totalCategoryAttempts;
  var value$4 = value.uniqueActivityCount;
  return {
          __typename: value.__typename,
          categoryId: value.categoryId,
          avgBestCategoryAttempts: !(value$1 == null) ? value$1 : undefined,
          avgLatestCategoryAttempts: !(value$2 == null) ? value$2 : undefined,
          totalCategoryAttempts: !(value$3 == null) ? value$3 : undefined,
          uniqueActivityCount: !(value$4 == null) ? value$4 : undefined,
          totalActivityCount: value.totalActivityCount
        };
}

function serialize$2(value) {
  var value$1 = value.totalActivityCount;
  var value$2 = value.uniqueActivityCount;
  var uniqueActivityCount = value$2 !== undefined ? value$2 : null;
  var value$3 = value.totalCategoryAttempts;
  var totalCategoryAttempts = value$3 !== undefined ? value$3 : null;
  var value$4 = value.avgLatestCategoryAttempts;
  var avgLatestCategoryAttempts = value$4 !== undefined ? value$4 : null;
  var value$5 = value.avgBestCategoryAttempts;
  var avgBestCategoryAttempts = value$5 !== undefined ? value$5 : null;
  var value$6 = value.categoryId;
  var value$7 = value.__typename;
  return {
          __typename: value$7,
          categoryId: value$6,
          avgBestCategoryAttempts: avgBestCategoryAttempts,
          avgLatestCategoryAttempts: avgLatestCategoryAttempts,
          totalCategoryAttempts: totalCategoryAttempts,
          uniqueActivityCount: uniqueActivityCount,
          totalActivityCount: value$1
        };
}

function verifyArgsAndParse$2(_AcademyMatrixCategoryAggregateFragment, value) {
  return parse$2(value);
}

function verifyName$2(param) {
  
}

var AcademyMatrixCategoryAggregateFragment = {
  Raw: Raw$2,
  query: query$2,
  parse: parse$2,
  serialize: serialize$2,
  verifyArgsAndParse: verifyArgsAndParse$2,
  verifyName: verifyName$2
};

var Raw$3 = {};

var query$3 = GraphqlTag.gql([
      "fragment AcademyMatrixAggregateFragment on AcademyMatrixAggregate   {\n__typename  \nfirst  \nlast  \nstudentId  \ncategoryAggregates  {\n...AcademyMatrixCategoryAggregateFragment   \n}\n\n}\n",
      ""
    ], query$2);

function parse$3(value) {
  var value$1 = value.categoryAggregates;
  return {
          __typename: value.__typename,
          first: value.first,
          last: value.last,
          studentId: value.studentId,
          categoryAggregates: value$1.map(function (value) {
                return parse$2(value);
              })
        };
}

function serialize$3(value) {
  var value$1 = value.categoryAggregates;
  var categoryAggregates = value$1.map(function (value) {
        return serialize$2(value);
      });
  var value$2 = value.studentId;
  var value$3 = value.last;
  var value$4 = value.first;
  var value$5 = value.__typename;
  return {
          __typename: value$5,
          first: value$4,
          last: value$3,
          studentId: value$2,
          categoryAggregates: categoryAggregates
        };
}

function verifyArgsAndParse$3(_AcademyMatrixAggregateFragment, value) {
  return parse$3(value);
}

function verifyName$3(param) {
  
}

var AcademyMatrixAggregateFragment = {
  Raw: Raw$3,
  query: query$3,
  parse: parse$3,
  serialize: serialize$3,
  verifyArgsAndParse: verifyArgsAndParse$3,
  verifyName: verifyName$3
};

export {
  MenuFragment ,
  ActivityFragment ,
  AcademyMatrixCategoryAggregateFragment ,
  AcademyMatrixAggregateFragment ,
}
/* query Not a pure module */
